import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useSaveSurveyAnswer = (userId, surveyId, status, typeSurvey) => {
  const mutation = useMutation((formData) => {
    const body = !typeSurvey? formData: formData.formData; 
    return axiosClient.post(`SurveyController/SaveSurveyAnswerUser?userId=${userId}&surveyId=${surveyId || formData.surveyId}&status=${status || formData.status}&typeSurvey=${typeSurvey}`, body);
  });
  return mutation;
};
export default useSaveSurveyAnswer;
